import { PropsWithChildren } from "react";
import { Outlet, useNavigate } from "react-router";

import { useCompleteTaskMutation } from "shared/tg/hooks/use-complete-task-mutation";
import { useStoreCertificateMutation } from "shared/tg/hooks/use-store-certificate-mutation";
import { useWatchStartParam } from "shared/tg/hooks/use-watch-start-param";
import { CertificateMetadata } from "shared/tg/types";

import { NavBar } from "./nav-bar";

export const Layout = (props: PropsWithChildren) => {
  const navigate = useNavigate();

  const mutation = useStoreCertificateMutation();
  const completeTaskMutation = useCompleteTaskMutation();
  const fetchCert = async (startParam: string) => {
    try {
      const certificateId = startParam;
      let standard: CertificateMetadata["standard"] = "gip1";
      let url = `https://tmakyc.lookhere.tech/certificate?id=${certificateId}`;

      if (startParam.includes("gip3")) {
        standard = "gip3";
        const preparedCertId = certificateId.replaceAll("_", ":");
        url = `https://api-guardian.occam.fi/download/${preparedCertId}`;
      }

      if (mutation.isPending) return;

      await mutation.mutateAsync({ url, certificateId, standard });

      await completeTaskMutation.mutateAsync({
        systemName: `generate-${standard}-cert`,
      });

      navigate("/my-certs");
    } catch {
      //
    }
  };

  useWatchStartParam((startParam) => {
    fetchCert(startParam);
  });

  return (
    <div className="grid h-full grow grid-rows-[1fr_minmax(0,auto)] overflow-y-auto bg-white">
      {props.children ?? <Outlet />}
      <NavBar className="shrink-0" />
    </div>
  );
};
